import { sortBy } from "lodash";
import { genSortedTypeKey, getTypeDefinition } from "./tools";
/**
 * 根据如下优先级排序类型：Enum Reference > Primitives > Tagged References > Entity > Structure > AnonymousStructure > Map > List
 * @param typeArguments 待排序的types
 * @returns
 */
export function sortTypeArgumentsBasedOnTypePriority(typeArguments) {
    const firstPass = sortBy(typeArguments, (arg) => {
        // 应用优先级排序规则 Primitives > Tagged References > Entity > Structure > AnonymousStructure > Map > List
        const typeKindListOrderedByPriority = ["primitive", "reference", "anonymousStructure", "generic"];
        if (arg.typeKind === "union") {
            throw new Error("Union类型的typeArguments不能再为union");
        }
        const priority = typeKindListOrderedByPriority.indexOf(arg.typeKind);
        return [priority, isTaggedReferenceType(arg) ? 0 : 1, isEntityReferenceType(arg) ? 0 : 1];
    });
    const secondPass = sortBy(firstPass, (arg) => {
        // 应用优先级排序规则：Enum Reference > Others
        const argTypeDef = getTypeDefinition(genSortedTypeKey(arg));
        if ((argTypeDef === null || argTypeDef === void 0 ? void 0 : argTypeDef.concept) === "Enum") {
            return 0;
        }
        return 1;
    });
    return secondPass;
    function isTaggedReferenceType(typeAnnotation) {
        var _a;
        // @ts-expect-error FIXME
        const properties = (_a = getTypeDefinition(genSortedTypeKey(typeAnnotation))) === null || _a === void 0 ? void 0 : _a.properties;
        return (typeAnnotation.typeKind === "reference" &&
            (properties === null || properties === void 0 ? void 0 : properties.filter((prop) => { var _a; return prop.name === "errorType" && ((_a = prop.expression) === null || _a === void 0 ? void 0 : _a.concept) === "StringLiteral"; })));
    }
    function isEntityReferenceType(typeAnnotation) {
        var _a;
        return (typeAnnotation.typeKind === "reference" &&
            // @ts-expect-error FIXME
            ((_a = getTypeDefinition(genSortedTypeKey(typeAnnotation))) === null || _a === void 0 ? void 0 : _a.concept) === "Entity");
    }
}
